module.exports = __webpack_public_path__ + "static/img/msg_tab5.b8f07ac8.png";